var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2435_2176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.50333C5.15685 6.50333 6.5 5.16018 6.5 3.50333C6.5 1.84647 5.15685 0.503326 3.5 0.503326C1.84315 0.503326 0.5 1.84647 0.5 3.50333C0.5 5.16018 1.84315 6.50333 3.5 6.50333Z",
    stroke: "#5F5457",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.5033C5.15685 15.5033 6.5 14.1602 6.5 12.5033C6.5 10.8465 5.15685 9.50333 3.5 9.50333C1.84315 9.50333 0.5 10.8465 0.5 12.5033C0.5 14.1602 1.84315 15.5033 3.5 15.5033Z",
    stroke: "#5F5457",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.50333C14.1569 6.50333 15.5 5.16018 15.5 3.50333C15.5 1.84647 14.1569 0.503326 12.5 0.503326C10.8431 0.503326 9.5 1.84647 9.5 3.50333C9.5 5.16018 10.8431 6.50333 12.5 6.50333Z",
    stroke: "#5F5457",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5033C14.1569 15.5033 15.5 14.1602 15.5 12.5033C15.5 10.8465 14.1569 9.50333 12.5 9.50333C10.8431 9.50333 9.5 10.8465 9.5 12.5033C9.5 14.1602 10.8431 15.5033 12.5 15.5033Z",
    stroke: "#5F5457",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2435_2176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.1264dad60b7a966a21eb61bf7436a46d.svg";
export { ForwardRef as ReactComponent };